import { firstNObjectValues } from "../typescriptUtils";

const HOTJAR_MAX_KEY_LENGTH = 50;
const HOTJAR_CONFIG_MAX_SETTINGS_DEFAULT = 80;

export const filterAndProcessHotjarSettings = (
  settings: Record<string, string>,
  maxNumberOfSettings: number = HOTJAR_CONFIG_MAX_SETTINGS_DEFAULT
): Record<string, string> => {
  // Filter out any setting values that are only integer values
  const filteredSettingValues = Object.fromEntries(
    Object.entries(settings)
      .filter(([key]) => {
        // Regular expression to test if the key is not only integer digits
        const regex = /^\d+$/;
        return !regex.test(key);
      })
      .map(([key, value]) => {
        // Truncate the key if it's longer than 50 characters
        const truncatedKey =
          key.length > HOTJAR_MAX_KEY_LENGTH
            ? key.substring(0, HOTJAR_MAX_KEY_LENGTH)
            : key;
        return [truncatedKey, value];
      })
  );

  const firstObjectValues = firstNObjectValues<string>(
    maxNumberOfSettings,
    filteredSettingValues
  );

  return firstObjectValues;
};
